import gql from "graphql-tag";

export const profilesGQL = gql`
  query Profiles {
    profiles {
      id
      userId
      username
      avatar
      isKidProfile
      locked
      isMainAccount
      isPinProtected
      language
    }
  }
`;

export const meProfileGQL = gql`
  query MeProfile {
    me {
      id
      profile {
        id
        userId
        username
        avatar
        isKidProfile
        locked
        isMainAccount
        isPinProtected
      }
    }
  }
`;
